<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>{{tag}} Log Detail</strong>
            <span class="float-right">Date : {{model.created_at | datetime}}</span>
          </div>
          <b-row>
            <b-col v-if="model.user_id && tag == 'USER'">
              <b-button block size="sm" class="float-right" variant="info" @click="is_modal = true">View User Info</b-button>
            </b-col>
            <!-- <b-col v-if="model.user_id && tag == 'USER'">
              <b-button block size="sm" class="float-right" variant="info" @click="is_modal = true">View Group</b-button>
            </b-col> -->
            <b-col v-if="model.partner_id && tag == 'PARTNER'">
              <b-button block size="sm" class="float-right" variant="warning" @click="is_modal = true">View Partner</b-button>
            </b-col>
            <b-col v-if="model.admin_id && tag == 'ADMIN'">
              <b-button block size="sm" class="float-right" variant="primary" @click="is_modal = true">View Admin</b-button>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="ph_username">Username</label>
                <b-form-input md=5 type="text" id="ph_username" :disabled="lock" v-model="model.username" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="ph_action">Action</label>
                <b-form-input md=5 type="text" id="ph_action" :disabled="lock" v-model="model.action" disabled></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="ph_addr">Address</label>
                <b-form-input md=5 type="text" id="ph_addr" :disabled="lock" v-model="model.action" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="ph_addr_all">Address All</label>
                <b-form-input md=5 type="text" id="ph_addr_all" :disabled="lock" v-model="model.addr_all" disabled></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col>
              <b-button block size="sm" class="float-right" variant="primary">Request raw data</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <pre>
                <JsonViewer
                v-if="model.info"
                :value="model.info"
                :expand-depth=5
                copyable
                boxed
                sort
                />
              </pre>
            </b-col>
          </b-row>
          <hr>
          <b-button size="sm" class="float-right" variant="primary" @click="list">List</b-button>
        </b-card>
      </b-col>
    </b-row>
    <!-- 정보성 모달 영역 -->
    <b-modal size="xl" title="Information"  v-model="is_modal" @ok="is_modal = false" ok-only ok-variant="success" header-bg-variant="success">
      <User v-if="model.user_id && tag == 'USER'" :user_id="model.user_id" />
      <Partner v-if="model.partner_id && tag == 'PARTNER'" :partner_id="model.partner_id" />
      <Admin v-if="model.admin_id && tag == 'ADMIN'" :admin_id="model.admin_id" />
    </b-modal>
  </div>
</template>

<script>
import { Api } from '@/service';
import User from '@/views/Management/user/User.Detail.Summary'
import Partner from '@/views/Management/partner/Partner.Detail.Summary'
import Admin from '@/views/Management/admin/Admin.Detail.Summary'
// import VueJsonPretty from 'vue-json-pretty';
// import 'vue-json-pretty/lib/styles.css';
import JsonViewer from 'vue-json-viewer'


export default {
  components: { JsonViewer, User, Partner, Admin },
  data : () => {
    return {
      model : { info : {} },
      tag : '',
      lock : true,
      is_modal : false
    }
  },
  methods: {
    list() { this.$router.push({ name: 'log_action'}); },
    async get( id = this.$route.params.id, tag = this.$route.params.tag) {
      console.log('log.action.detail.vue', 'load item', id, tag);
      this.tag = this.$route.params.tag.toUpperCase();
      try {
        let rs = await Api.Manager_Call('log.action', `detail.${this.$route.params.tag}`, { id : Number(id.id) })
        if(rs.error) { return this.$toastr.e("get data tailed") }

        this.model = Object.assign({}, this.model, rs.body);

        try { this.model.info = JSON.parse(this.model.info) }
        catch(e) { console.log('info is not json') }

      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('log.action.detail.vue', 'created'); },
  destroyed() { console.log('log.action.detail.vue', 'destroyed'); },
  mounted() {
    console.log('log.action.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
